import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Helper } from "@helpers/functions";
import { SelfCertificationModel } from "@modules/taxes/domain/entities/taxes.model";
import { TAXES_NOT_ELIGIBLE_COOKIE_KEY } from "@helpers/constants";
import { Observable } from "rxjs";

export interface TaxesUserState {
	hasError: boolean;
	isLoading: boolean;
	taxStatus: string;
	declarationsOpen: number;
	isUpdatingStatus: boolean;
	declarationsOpenForWallet: number;
}

const initialState: TaxesUserState = {
	hasError: false,
	isLoading: true,
	taxStatus: "",
	declarationsOpen: 0,
	isUpdatingStatus: false,
	declarationsOpenForWallet: 0
};

@Injectable({
	providedIn: "root"
})
export class TaxesStateService extends StateService<TaxesUserState> {
	public isLoading$ = this.select((state) => state.isLoading);
	public hasError$ = this.select((state) => state.hasError);
	public taxStatus$ = this.select((state) => state.taxStatus);
	public declarationsOpen$ = this.select((state) => state.declarationsOpen);
	public isUpdatingStatus$ = this.select((state) => state.isUpdatingStatus);

	public constructor() {
		super(initialState);
	}

	public getTaxesState$(): Observable<TaxesUserState> {
		return this.select((state) => state);
	}

	public updateState(model: Partial<TaxesUserState>): void {
		this.setState(model);
	}

	public hasError(): boolean {
		return this.state?.hasError;
	}

	public stateNotLoaded(): boolean {
		return this.state.taxStatus === "";
	}

	public taxesErrorState(): void {
		this.updateState({
			hasError: true,
			isLoading: false,
			taxStatus:
				Helper.getCookie(TAXES_NOT_ELIGIBLE_COOKIE_KEY, true) !== "true"
					? SelfCertificationModel.NonEligible
					: "",
			declarationsOpen: 0,
			isUpdatingStatus: false
		});
	}

	public updateStatusInProgress(isLoading: boolean): void {
		this.updateState({
			isUpdatingStatus: isLoading
		});
	}

	public userHasDeclarationsOpen(): boolean {
		return this.state?.declarationsOpen > 0;
	}

	public hasDeclarationsOpenForWallet(): boolean {
		return this.state?.declarationsOpenForWallet > 0;
	}
}
